import { userService } from '@saucelabs/sl-util-axios';

/* eslint import/prefer-default-export: 0 */
export const getFilters = (qs) => (
  userService.get('/v1/users/filters/', {
    params: qs,
  })
);
